// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  authSettings: {
    clientId: '625a15ab-b7f3-48b2-ac26-b7d921ee0056',
    tenant: 'honoccupantidentity.onmicrosoft.com',
    expireOffsetSeconds: 3000,
    endpoints: {
      'https://phbsportal.azure-api.net/portal/v1/api/': 'https://honoccupantidentity.onmicrosoft.com/hbsportalapi/'
    },
    ocpApimSubscriptionKey: 'fa80c243e9254c259060a2b3c51c8d89',
    organizationId: '',
    getRoleUrl: 'https://phbsportal.azure-api.net/portal/v1/api/User/RolesAndPrivileges/',
    getRoleResource: 'https://honoccupantidentity.onmicrosoft.com/hbsportalapi/',
  },
  orgSettingsApiUrl: 'https://phbsportal.azure-api.net/portal/v1/api/Settings',
  orgPresalesSettingsApiUrl: 'https://phbsportal.azure-api.net/portal/v1/api/PresalesSettings',
  fileUploadUrl: 'https://phbsportal.azure-api.net/portal/v1/api/file/upload',
  fileContentUrl: 'https://phbsportal.azure-api.net/portal/v1/api/file/content',
  ocpApimSubscriptionKey: 'fa80c243e9254c259060a2b3c51c8d89',
  dmsPortalUrl: 'https://honeywellprod.sharepoint.com/teams/OBS-DMS/SitePages/Home.aspx',
  CORToolUrl: 'https://honeywellprod.sharepoint.com/:f:/r/teams/OBS-DMS/OBS%20Project%20Files/ProcessDocuments%26Tools/EBI%20-%20OBS%20Site%20Information%20Gathering%20Tool',
  gatewayTenantAccountApiUrl: 'https://fc.api.gatewaymgr.honeywell.com/api/tenants',
  gatewayManagerAPIKongAuthKey: 'coNWN7BxoTgMtBsUVRIVxuUrU9Rqqoo9',
  cdt: {
    api_url: 'https://papi.honeywellcloud.com/modeleditor-api/',
    ttl: 15,
    refreshInterval: 25000
  },
  historyValidation: {
    historyValidationServiceUrl: 'https://phbsportal.azure-api.net/portal/v1/api/history-validation/',
    historyValidationOcpApimSubscriptionKey: 'fa80c243e9254c259060a2b3c51c8d89'
  },
  eventLogger: {
    api_url: 'https://prod-cbld-adminportal-onboardingworkflowapi.platform.honeywellforge.com/api/'
  },
  launchDarklyClientId: '58f89a9f5a64a10a1bc8aae1',
  launchDarklyUserKey: 'sdk-32de31b6-c8ca-4bdf-9d1a-71e0012db129'
};
